import styled from "styled-components";

export const KeyboardOverlay = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  display: flex;
  justify-content: center;
  pointer-events: ${(props) => (props.isVisible ? "auto" : "none")};
  transform: translateY(${(props) => (props.isVisible ? "0" : "100%")});
  transition: transform 0.3s ease-in-out;
  max-height: 65vh;

  @media (min-width: 1680px) {
    max-height: 60vh;
  }

  @media (max-width: 768px) {
    max-height: 70vh;
  }
`;

export const KeyboardContainer = styled.div`
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-bottom: none;
  border-radius: 16px 16px 0 0;
  padding: 15px 32px 32px 32px;
  box-shadow: 0 -6px 24px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  position: relative;
  height: 100%;
  overflow: hidden;

  @media (min-width: 1680px) {
    max-width: 1300px;
    padding: 20px 40px 40px 40px;
    gap: 14px;
  }

  @media (max-width: 768px) {
    padding: 12px 20px 20px 20px;
    max-width: 100%;
    border-radius: 8px 8px 0 0;
    gap: 8px;
  }
`;

export const KeyboardCloseHeader = styled.button`
  position: absolute;
  right: 15px;
  top: 10px;
  z-index: 1;
  background: none;
  border: none;
  font-size: 24px;
  color: #6c757d;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  transition: all 0.2s ease;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (min-width: 1680px) {
    font-size: 28px;
    padding: 6px 12px;
    border-radius: 8px;
  }

  @media (max-width: 768px) {
    font-size: 20px;
    padding: 4px 8px;
    border-radius: 4px;
  }

  &:hover {
    background: #e9ecef;
    color: #495057;
  }
`;

export const KeyboardRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  align-items: center;

  @media (min-width: 1680px) {
    gap: 14px;
  }

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const KeyboardKey = styled.button`
  background: #ffffff;
  border: 1px solid #ced4da;
  border-radius: 8px;
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
  user-select: none;

  @media (min-width: 1680px) {
    width: 80px;
    height: 80px;
    font-size: 26px;
    border-radius: 10px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    width: 38px;
    height: 38px;
    font-size: 17px;
    border-radius: 6px;
  }

  &:hover {
    background: #e9ecef;
    border-color: #adb5bd;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.18);
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    background: #dee2e6;
  }
`;

export const KeyboardBackspace = styled(KeyboardKey)`
  width: 100px;
  background: #6c757d;
  color: white;
  border-color: #6c757d;
  font-size: 24px;

  @media (min-width: 1680px) {
    width: 125px;
    font-size: 28px;
  }

  @media (max-width: 768px) {
    width: 65px;
    font-size: 20px;
  }

  &:hover {
    background: #5a6268;
    border-color: #545b62;
  }

  &:active {
    background: #545b62;
  }
`;

export const KeyboardClear = styled(KeyboardKey)`
  width: 110px;
  background: #dc3545;
  color: white;
  border-color: #dc3545;
  font-size: 20px;

  @media (min-width: 1680px) {
    width: 135px;
    font-size: 22px;
  }

  @media (max-width: 768px) {
    width: 75px;
    font-size: 16px;
  }

  &:hover {
    background: #c82333;
    border-color: #bd2130;
  }

  &:active {
    background: #bd2130;
  }
`;

export const KeyboardClose = styled(KeyboardKey)`
  width: 85px;
  background: #868e96;
  color: white;
  border-color: #868e96;
  font-size: 14px;

  @media (min-width: 1680px) {
    width: 105px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 65px;
    font-size: 13px;
  }

  &:hover {
    background: #6f7679;
    border-color: #6f7679;
  }

  &:active {
    background: #6f7679;
  }
`;

export const KeyboardCapsLock = styled(KeyboardKey)`
  width: 95px;
  background: ${(props) => (props.isActive ? "#495057" : "#ffffff")};
  color: ${(props) => (props.isActive ? "white" : "#495057")};
  border-color: ${(props) => (props.isActive ? "#495057" : "#ced4da")};
  font-size: 14px;
  font-weight: 600;

  @media (min-width: 1680px) {
    width: 115px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 65px;
    font-size: 12px;
  }

  &:hover {
    background: ${(props) => (props.isActive ? "#343a40" : "#e9ecef")};
    border-color: ${(props) => (props.isActive ? "#343a40" : "#adb5bd")};
  }

  &:active {
    background: ${(props) => (props.isActive ? "#343a40" : "#dee2e6")};
  }
`;

export const KeyboardShift = styled(KeyboardKey)`
  width: 100px;
  background: ${(props) => (props.isActive ? "#495057" : "#ffffff")};
  color: ${(props) => (props.isActive ? "white" : "#495057")};
  border-color: ${(props) => (props.isActive ? "#495057" : "#ced4da")};
  font-size: 20px;
  font-weight: 600;

  @media (min-width: 1680px) {
    width: 125px;
    font-size: 24px;
  }

  @media (max-width: 768px) {
    width: 70px;
    font-size: 17px;
  }

  &:hover {
    background: ${(props) => (props.isActive ? "#343a40" : "#e9ecef")};
    border-color: ${(props) => (props.isActive ? "#343a40" : "#adb5bd")};
  }

  &:active {
    background: ${(props) => (props.isActive ? "#343a40" : "#dee2e6")};
  }
`;

export const KeyboardSpecial = styled(KeyboardKey)`
  width: 95px;
  background: ${(props) => (props.isActive ? "#17a2b8" : "#ffffff")};
  color: ${(props) => (props.isActive ? "white" : "#17a2b8")};
  border-color: ${(props) => (props.isActive ? "#17a2b8" : "#17a2b8")};
  font-size: 14px;
  font-weight: 600;

  @media (min-width: 1680px) {
    width: 115px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    width: 65px;
    font-size: 12px;
  }

  &:hover {
    background: ${(props) => (props.isActive ? "#138496" : "#e9ecef")};
    border-color: ${(props) => (props.isActive ? "#138496" : "#138496")};
  }

  &:active {
    background: ${(props) => (props.isActive ? "#138496" : "#dee2e6")};
  }
`;

export const KeyboardSpace = styled(KeyboardKey)`
  width: 320px;

  @media (min-width: 1680px) {
    width: 400px;
  }

  @media (max-width: 768px) {
    width: 160px;
  }
`;

export const KeyboardEnter = styled(KeyboardKey)`
  width: 115px;
  background: #004e9b;
  color: white;
  border-color: #004e9b;
  font-size: 18px;
  font-weight: 600;

  @media (min-width: 1680px) {
    width: 140px;
    font-size: 20px;
  }

  @media (max-width: 768px) {
    width: 80px;
    font-size: 15px;
  }

  &:hover {
    background: #003d7a;
    border-color: #003d7a;
  }

  &:active {
    background: #002d5a;
  }
`;
